import React, { useEffect } from "react";
import "./company.css";
import Navbar from "../../../components/Navbar/Navbar";
import Blacknavtop from "../../../components/Navbar/Blacknavtop";
import Footer from "../../../components/footer/main";
import Aos from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import { Container } from "@material-ui/core";
import Typist from "react-typist";

const Tax = () => {
  return (
    <div className="">
      <Blacknavtop />
      <Navbar />

      <div className="pt_10rem bg_smoke pb_5rem">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <p className="text-muted">
                /<a href="/">service</a>/
                <a href="/service/company-registration">company-registration</a>
              </p>
              <br />
              <h1
                data-aos="fade-right"
                className="fs25 hh"
                // className="text-center"
                // style={{ width: "80%", margin: "auto" }}
              >
                GET YOUR <span className="t-blue"> STARTUP/COMPANY</span>
                <br />
                REGISTERED IN 1 CALL
              </h1>

              <p className="text-muted fs11">
                Your idea can be the next big thing if you work for it.
              </p>
              <a
                style={{ textDecoration: "none", color: "black" }}
                href="tel:8851956910"
                target="_blank"
              >
                <button type="button" class="btn btn-primary fullbtn mr7" style={{ width: "40%" }}>
                  CALL US
                </button>
              </a>
            </div>
            <div className="col-lg-4">
              <img src={require("../../../Assets/idea.svg")} width="100%" />
            </div>
          </div>
          <br />
          <br />
        </div>
      </div>
      <div></div>
      <Howitworks />
      <Pricing />
      <ExpertAssistance />
      <Footer />
    </div>
  );
};

const Pricing = () => {
  return (
    <div>
      <div className="container pt_5rem pb_5rem">
        <h2 className="text-center " style={{ width: "80%", margin: "auto" }}>
          Our Fees?
        </h2>
        <div className="pt_30 text-center">
          <h3 className="font-weight-400">Our pricing is very transparent and nominal.</h3>
          <h3 className="font-weight-400">
            Company Registration Services are starting from :{" "}
            <span className="t-blue">999 INR</span>
          </h3>
        </div>
      </div>
    </div>
  );
};

const Howitworks = () => {
  return (
    <div>
      <div className="container pt_5rem">
        <h2 className="text-center" style={{ width: "80%", margin: "auto" }}>
          How We work!
        </h2>
        <div className="row pt_30">
          <div className="col-lg-4">
            <HowStep
              step="1"
              head="Call us and give details"
              sub="Inquire us about anything on call as we are transparent about our fees and process."
              image="upload.svg"
            />
          </div>
          <div className="col-lg-4">
            <HowStep
              step="2"
              head="We get to work"
              sub="We will remain in contact with you from very beginning and reviews and edits."
              image="customer-service.svg"
            />
          </div>
          <div className="col-lg-4">
            <HowStep
              step="3"
              head="Payment on completion"
              sub="We will file with govt. and you will get the acknowledgement from government."
              image="complete.svg"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const HowStep = (props) => {
  return (
    <div className="shortservice_div bg_white">
      <img
        className="shortservice_img"
        src={require(`../../../Assets/${props.image}`)}
        width="60px"
      />
      <p className="text-muted pt_5">STEP - {props.step}</p>
      <h2 className="howservice_h2">{props.head}</h2>
      <p className="text-grey">{props.sub}</p>
    </div>
  );
};

const ExpertAssistance = () => {
  return (
    <div className="pt_5rem pb_5rem ">
      <div className="container bg_smoke pt_2rem pb_2rem br_12px">
        <h1 className="text-center font-weight-bold">OUR EXPERT ASSISTANCE</h1>
        <br />
        <br />

        <div className="taxresponsive_div ">
          <div className="row">
            <div className="col-lg-6">
              <Tickservice text="Your data is reviewed and corrected." />
              <Tickservice text="Best tax saving options." />
              <Tickservice text="ITR filings for your company." />
              <Tickservice text="Various other finance services." />
            </div>
            <div className="col-lg-6">
              <Tickservice text="Tax guidance provided." />
              <Tickservice text="IT guidance." />
              <Tickservice text="Post return filing updates." />
            </div>
          </div>
          <br />
          <div className="text-center">
            <a
              style={{ textDecoration: "none", color: "black" }}
              href="tel:8851956910"
              target="_blank"
            >
              <button type="button" class="btn btn-primary fullbtngreen mr7">
                CALL / WHATSAPP
              </button>
            </a>
          </div>
        </div>
        <br />
        <br />
      </div>
    </div>
  );
};

const Tickservice = (props) => {
  return (
    <div>
      <div className="row">
        <div className="col-2">
          <img src={require("../../../Assets/tick.svg")} width="100%" />
        </div>
        <div className="col-10">{props.text}</div>
      </div>
    </div>
  );
};

export default Tax;
